import React, {Component} from 'react'
import axios from 'axios'
import {Icon} from 'antd'

import 'styles/list.css'

class Lists extends Component {
  constructor() {
    super();
    this.state = {
      list: [
        {
          'title': '百度搜索',
          'img': 'feature_1.png',
          'url': 'www.baidu1.com'
        },
        {
          'title': '天气查询',
          'img': 'feature_2.png',
          'url': 'www.baidu2.com'
        },
        {
          'title': '快递查询',
          'img': 'feature_3.png',
          'url': 'www.baidu3.com'
        },
        {
          'title': '在线问诊',
          'img': 'feature_4.png',
          'url': 'www.baidu4.com'
        },
        {
          'title': '优酷直播',
          'img': 'feature_5.png',
          'url': 'www.baidu5.com'
        },
        {
          'title': '江苏智天下',
          'img': 'feature_6.png',
          'url': 'www.baidu6.com'
        }
      ]
      // list: []
    };
  }

  componentDidMount() {
    // this.ajaxData();
  }

  render() {
    let that = this;
    return (
      <div className='container'>
        <div className='top-box'>
          <a href='#/service'>
            <Icon type='left'/>
            <span>更多服务</span>
          </a>
        </div>
        <div className='list ant-list ant-list-sm ant-list-bordered content-main'>
          <ul>
            {this.state.list.map((item, index) => {
              return (
                <li data-url={item.url} onClick={that.handleClick.bind(that, event)} className='ant-list-item'
                    key={index}>
                  <img src={'images/' + item.img} alt={item.img}/>
                  <span>{item.title}</span>
                  <Icon type='right'/>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    )
  }

  ajaxData() {
    let that = this;
    axios.get('api/list.json').then(response => {
      if (response.data.success === 0) {
        that.setState({
          list: response.data.data
        });
      }
    });
  }

  handleClick(target, event) {
    alert('你当前点击的网址是' + event.currentTarget.getAttribute('data-url') + '网站名是' + event.currentTarget.innerText);
  }
}

export default Lists;




// WEBPACK FOOTER //
// ./src/pages/list.js